"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoGeneralBlNo = autoGeneralBlNo;
exports.batchCommit = batchCommit;
exports.bookingHeadWebInitProps = bookingHeadWebInitProps;
exports.checkPageAccessPermission = checkPageAccessPermission;
exports.checkQueryNotice = checkQueryNotice;
exports.combineDataNew = combineDataNew;
exports.combineDataValidate = combineDataValidate;
exports.deleteAmendFile = deleteAmendFile;
exports.deleteByFileId = deleteByFileId;
exports.deleteFile = deleteFile;
exports.doApplyFt = doApplyFt;
exports.doReturnDraft = doReturnDraft;
exports.downloadFile = downloadFile;
exports.downloadFileCargo = downloadFileCargo;
exports.downloadFileNoticePdf = downloadFileNoticePdf;
exports.excelImport2 = excelImport2;
exports.excelImport3 = excelImport3;
exports.excelImportDocument = excelImportDocument;
exports.exportBookingHistory = exportBookingHistory;
exports.forgetAccount = forgetAccount;
exports.forgetPwd = forgetPwd;
exports.getAgreementNoFlag = getAgreementNoFlag;
exports.getByBookingHeadWebComId = getByBookingHeadWebComId;
exports.getCdmChargeCode = getCdmChargeCode;
exports.getContainerTypeByNo = getContainerTypeByNo;
exports.getFileInfo = getFileInfo;
exports.getFreeTimeNo = getFreeTimeNo;
exports.getFreetimelnfo = getFreetimelnfo;
exports.getLatestRegisterTerms = getLatestRegisterTerms;
exports.getLockByDoc = getLockByDoc;
exports.getMyTemplate = getMyTemplate;
exports.getQueryListCodeName = getQueryListCodeName;
exports.getSaleByAccountNo = getSaleByAccountNo;
exports.getUrlForFreeTime = getUrlForFreeTime;
exports.getUrlStrForHBLMat = getUrlStrForHBLMat;
exports.getUrlStrForPreview = getUrlStrForPreview;
exports.getUrlStrForPreviewKR = getUrlStrForPreviewKR;
exports.getUrlStrForPreviewSo = getUrlStrForPreviewSo;
exports.getVgmContainerWeight = getVgmContainerWeight;
exports.getWebOnlineTermsByAccount = getWebOnlineTermsByAccount;
exports.loadBkVgmContainers = loadBkVgmContainers;
exports.myTemplateSave = myTemplateSave;
exports.queryBkCustomerRf = queryBkCustomerRf;
exports.queryEbVerBookingHeadComById = queryEbVerBookingHeadComById;
exports.queryListCargoType = queryListCargoType;
exports.queryListCode = queryListCode;
exports.queryListCodeName = queryListCodeName;
exports.queryListCommodity = queryListCommodity;
exports.queryListCustomerSipg = queryListCustomerSipg;
exports.queryListMainVessel = queryListMainVessel;
exports.queryListPackageType = queryListPackageType;
exports.queryListPort = queryListPort;
exports.queryListPortConfiguration = queryListPortConfiguration;
exports.queryListPortFacility = queryListPortFacility;
exports.queryListRolePort = queryListRolePort;
exports.queryListRoute = queryListRoute;
exports.queryListSimisCustomer = queryListSimisCustomer;
exports.queryListVessel = queryListVessel;
exports.queryListVoyagePlan = queryListVoyagePlan;
exports.queryListVoyagePlanThink = queryListVoyagePlanThink;
exports.queryVoyagePlanPage = queryVoyagePlanPage;
exports.saveCancelBookingHeadWebCom = saveCancelBookingHeadWebCom;
exports.saveOrUpdateAmendBkWebCom = saveOrUpdateAmendBkWebCom;
exports.saveOrUpdateAmendBkWebCom2 = saveOrUpdateAmendBkWebCom2;
exports.saveOrUpdateByMutiCopy = saveOrUpdateByMutiCopy;
exports.saveOrUpdateByMutiCopySingle = saveOrUpdateByMutiCopySingle;
exports.saveVoyageAdjust = saveVoyageAdjust;
exports.saveWithChild = saveWithChild;
exports.saveWithdrawBookingHeadWebCom = saveWithdrawBookingHeadWebCom;
exports.searchBlComForAdjust = searchBlComForAdjust;
exports.searchReleaseHistory = searchReleaseHistory;
exports.searchReleaseHistoryDownload = searchReleaseHistoryDownload;
exports.searchReleaseHistorySaves = searchReleaseHistorySaves;
exports.searchReleaseHistoryUploadLog = searchReleaseHistoryUploadLog;
exports.searhBookingHeadWebComHistory = searhBookingHeadWebComHistory;
exports.setDownloadFile = setDownloadFile;
exports.setUploadFile = setUploadFile;
exports.uploadFileCargo = uploadFileCargo;
exports.validateBkLock = validateBkLock;
exports.validateCargoDesc = validateCargoDesc;
exports.validateContainerNo = validateContainerNo;
exports.validateFeeInfo = validateFeeInfo;
exports.validatePortPermission = validatePortPermission;
exports.validateVoyageAdjust = validateVoyageAdjust;
exports.vgmImportvalidateContainerNo = vgmImportvalidateContainerNo;
var _request = _interopRequireDefault(require("@/utils/request"));
// 订舱查询
function queryVoyagePlanPage(data) {
  return (0, _request.default)({
    url: '/ebusiness/svlVoyagePlan/queryVoyagePlanPage',
    method: 'post',
    data: data
  });
}

// 获取港口列表
function queryListPort(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListPort',
    method: 'get',
    params: data
  });
}
//上线口岸配置
function queryListPortConfiguration(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListPortConfiguration',
    method: 'get',
    params: data
  });
}
function queryListRolePort(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListRolePort',
    method: 'get',
    params: data
  });
}
function queryListSimisCustomer(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListSimisCustomer',
    method: 'get',
    params: data
  });
}

// 获取船舶列表
function queryListVessel(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListVessel',
    method: 'get',
    params: data
  });
}
// 获取船舶列表
function queryListMainVessel(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListMainVessel',
    method: 'get',
    params: data
  });
}
// 获取航线列表
function queryListRoute(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListServiceLine',
    method: 'get',
    params: data
  });
}
// 保存订舱
function saveWithChild(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/saveWithChild',
    method: 'post',
    data: data
  });
}
// 获取船期信息
function queryListVoyagePlan(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListVoyagePlan',
    method: 'get',
    params: data
  });
}
function queryListVoyagePlanThink(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListVoyagePlanThink',
    method: 'get',
    params: data
  });
}
// 包装类型
function queryListPackageType(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListPackageType',
    method: 'get',
    params: data
  });
}
// 运输条款
function queryListCode(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCode',
    method: 'get',
    params: data
  });
}
function getQueryListCodeName(type) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCodeName?type=' + type,
    method: 'get'
  });
}

// 货物类型
function queryListCodeName(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCodeName',
    method: 'get',
    params: data
  });
}
// 港口设施
function queryListPortFacility(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListPortFacility',
    method: 'get',
    params: data
  });
}
// 订舱明细
function bookingHeadWebInitProps(params) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/loadBookingHeadWebInitProps/".concat(params),
    method: 'get'
  });
}

//补料核对
function queryEbVerBookingHeadComById(id) {
  return (0, _request.default)({
    url: "/ebusiness/ebVerBookingHeadCom/getById/".concat(id),
    method: 'get'
  });
}
// 船名航次调整
function saveVoyageAdjust(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/saveVoyageAdjust',
    method: 'post',
    data: data
  });
}

// 获取我的订舱
function searhBookingHeadWebComHistory(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/searhBookingHeadWebComHistory',
    method: 'post',
    data: data
  });
}
// 忘记密码
function forgetPwd(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/forgetPwd',
    method: 'get',
    params: data
  });
}
// 忘记账号
function forgetAccount(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/forgetAccount',
    method: 'get',
    params: data
  });
}
// 批量拷贝
function saveOrUpdateByMutiCopy(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/saveOrUpdateByMutiCopy',
    method: 'post',
    data: data
  });
}
// 批量推广拷贝
function saveOrUpdateByMutiCopySingle(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/saveOrUpdateByMutiCopySingle',
    method: 'post',
    data: data
  });
}
// Document import(Kp)导入
function excelImportDocument(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/excelImportDocument',
    method: 'post',
    data: data
  });
}
// 费用代码
function getCdmChargeCode(data) {
  return (0, _request.default)({
    url: '/ebusiness/cdmChargeCode/getCdmChargeCode',
    method: 'post',
    data: data
  });
}
function saveOrUpdateAmendBkWebCom(params) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/saveCommitBookingHeadWebCom/".concat(params),
    method: 'get'
  });
}
// 获取业务员
function getSaleByAccountNo(params) {
  return (0, _request.default)({
    url: "/sitceb-system-service/ebSysAccountRolePort/getSaleByAccountNo",
    method: 'get',
    params: params
  });
}

//船名航次调整
function searchBlComForAdjust(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/searchBlComForAdjust',
    method: 'post',
    data: data
  });
}
// 保存补料明细
function saveOrUpdateAmendBkWebCom2(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/saveOrUpdateAmendBkWebCom2',
    method: 'post',
    data: data
  });
}
// 获取vgm信息
function loadBkVgmContainers(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBkVgmContainer/loadBkVgmContainers',
    method: 'post',
    data: data
  });
}
// 货类联想控件
function queryListCargoType(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCargoType',
    method: 'get',
    params: data
  });
}
// vgm同步信息计算
function getVgmContainerWeight(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/getVgmContainerWeight',
    method: 'post',
    data: data
  });
}
// [我的订舱]箱信息&VGMExcel导入
function excelImport2(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/excelImport2',
    method: 'post',
    data: data
  });
}
// [补料明细]箱信息&VGMExcel导入
function excelImport3(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/excelImport3',
    method: 'post',
    data: data
  });
}
// 放单申请列表
function searchReleaseHistory(data) {
  return (0, _request.default)({
    url: '/ebusiness/docReleaseApplication/searchReleaseHistory',
    method: 'post',
    data: data
  });
}
// 放单申请
function searchReleaseHistorySaves(data) {
  return (0, _request.default)({
    url: '/ebusiness/docReleaseApplication/saves',
    method: 'post',
    data: data
  });
}
// 电放保函预览
function searchReleaseHistoryDownload(params) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/docReleaseApplication/download/".concat(params),
    method: 'get'
  });
}
// 电放保函上传

function searchReleaseHistoryUploadLog(data) {
  return (0, _request.default)({
    url: '/ebusiness/docReleaseApplication/uploadLog',
    method: 'post',
    data: data
  });
}
// 上传文件公共接口
function setUploadFile(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/file/uploadFile',
    method: 'post',
    data: data
  });
}
// 获取f/t申请信息
function getFreetimelnfo(params) {
  return (0, _request.default)({
    url: "/ebusiness/mktFreeTime/getFreeTimeInfo/".concat(params),
    method: 'get'
  });
}
//下载
function setDownloadFile(fileId) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/sitceb-system-service/file/downloadFile/".concat(fileId),
    method: 'get'
  });
}
function deleteByFileId(fileId) {
  return (0, _request.default)({
    url: "/sitceb-system-service/file/deleteFile/".concat(fileId),
    method: 'get'
  });
}
// 获取f/t申请导出
function getUrlForFreeTime(params) {
  return (0, _request.default)({
    url: "/ebusiness/mktFreeTime/getUrlForFreeTime/".concat(params),
    method: 'get'
  });
}
// 获取f/t申请导入
function doApplyFt(data) {
  return (0, _request.default)({
    url: '/ebusiness/mktFreeTime/doApplyFt',
    method: 'post',
    data: data
  });
}
// f/t保存草稿
function doReturnDraft(data) {
  return (0, _request.default)({
    url: '/ebusiness/mktFreeTime/doReturnDraft',
    method: 'post',
    data: data
  });
}
// 我的订舱模板保存
function myTemplateSave(data) {
  return (0, _request.default)({
    url: '/ebusiness/ebTemplateBookingHeadCom/save',
    method: 'post',
    data: data
  });
}
// 我的订舱模板明细
function getMyTemplate(params) {
  return (0, _request.default)({
    url: "/ebusiness/ebTemplateBookingHeadCom/getById/".concat(params),
    method: 'get'
  });
}
// 订舱撤回
function saveWithdrawBookingHeadWebCom(params) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/saveWithdrawBookingHeadWebCom/".concat(params),
    method: 'get'
  });
}
// 订舱取消
function saveCancelBookingHeadWebCom(params) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/saveCancelBookingHeadWebCom/".concat(params),
    method: 'get'
  });
}
// 打印
function getUrlStrForPreview(params) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/getUrlStrForPreview/".concat(params),
    method: 'get'
  });
}
// 主单分单校验

function getUrlStrForHBLMat(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/getUrlStrForHBLMatch',
    method: 'post',
    data: data
  });
}
// 是否单证锁船
function getLockByDoc(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/getLockByDoc',
    method: 'post',
    data: data
  });
}
//获取文件
function downloadFile(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/sitceb-system-service/file/downloadFile/".concat(data),
    method: 'get'
  });
}
//删除文件
function deleteFile(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/sitceb-system-service/file/deleteFile/".concat(data),
    method: 'get'
  });
}
//授权客户
function queryListCustomerSipg(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCustomerSipg',
    method: 'get',
    params: data
  });
}
// 品名联想控件
function queryListCommodity(data) {
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCommodity',
    method: 'get',
    params: data
  });
}
// 货物上传文件
function uploadFileCargo(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/uploadFile',
    method: 'post',
    data: data
  });
}
// 货物信息文件查询接口
function getByBookingHeadWebComId(data) {
  return (0, _request.default)({
    url: "/ebusiness/webBkUploadFiles/getByBookingHeadWebComId/".concat(data),
    method: 'get'
  });
}
// 货物信息文件删除接口get
function deleteAmendFile(data) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/deleteAmendFile/".concat(data),
    method: 'get'
  });
}
// 货物信息下载文件Get
function downloadFileCargo(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/webBookingHeadCom/downloadFile/".concat(data),
    method: 'get'
  });
}
// 注册信息
function getLatestRegisterTerms() {
  return (0, _request.default)({
    url: '/sitceb-system-service/webOnlineTerms/getLatestRegisterTerms',
    method: 'get'
  });
}
function getWebOnlineTermsByAccount() {
  return (0, _request.default)({
    url: '/sitceb-system-service/webOnlineTerms/getWebOnlineTermsByAccount',
    method: 'get'
  });
}
// 判断是否有没有权限
function checkPageAccessPermission(params) {
  return (0, _request.default)({
    url: "/sitceb-system-service/ebSysMenu/checkPageAccessPermission?path=".concat(params, "&appCode=SITCEB_BOOKING"),
    method: 'get'
  });
}
// 我的订舱导出
function exportBookingHistory(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/webBookingHeadCom/exportBookingHistory',
    method: 'post',
    data: data
  });
}
// 韩国查看预览
function getUrlStrForPreviewKR(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/getUrlStrForPreviewKR',
    method: 'post',
    data: data
  });
}
// 我的订单查看SO
function getUrlStrForPreviewSo(data) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/getUrlStrForPreviewSo/".concat(data),
    method: 'get'
  });
}
// 判断有没有订舱号出号
function autoGeneralBlNo(data) {
  return (0, _request.default)({
    url: "/ebusiness/webBookingHeadCom/autoGeneralBlNo/".concat(data),
    method: 'get'
  });
}
// 检查通告是否配置
function checkQueryNotice(data) {
  return (0, _request.default)({
    url: '/ebusiness/webNoticeConfig/queryNotice',
    method: 'post',
    data: data
  });
}
// 获取pdf文件（公告附件下载）
function downloadFileNoticePdf(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/webNoticeConfig/downLoadAttach',
    method: 'post',
    data: data
  });
}
function getFileInfo(fileId) {
  return (0, _request.default)({
    url: "/sitceb-system-service/docMinioFile/getByFileId/".concat(fileId),
    method: 'get'
  });
}
// 判断是否有港口权限
function validatePortPermission(data) {
  return (0, _request.default)({
    url: "/sitceb-system-service/ebSysAccountRolePort/validatePortPermission/".concat(data),
    method: 'get'
  });
}
// 判断有没有敏感词
function validateCargoDesc(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/validateCargoDesc',
    method: 'post',
    data: data
  });
}
// 并单自动确认校验
function combineDataValidate(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom2/combineDataValidate',
    method: 'post',
    data: data
  });
}
// 并单自动确认
function combineDataNew(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom2/combineData',
    method: 'post',
    data: data
  });
}
// 判断是否为长期协议号
function getAgreementNoFlag(id) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/getLongAgreementNoFlag/' + id,
    method: 'get'
  });
}
// 输入箱号，自动带出箱型
function getContainerTypeByNo(no) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/findContainerTypeByNo/' + no,
    method: 'get'
  });
}
// 船名航次调整校验
function validateVoyageAdjust(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/validateVoyageAdjust',
    method: 'post',
    data: data
  });
}

// 舱单锁定校验
function validateBkLock(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/validateBkLock',
    method: 'post',
    data: data
  });
}

// 附加费杂费校验
function validateFeeInfo(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/validateFeeInfo',
    method: 'post',
    data: data
  });
}

// 根据协议号获取FT
function getFreeTimeNo(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/getFreeTimeNo',
    method: 'post',
    data: data
  });
}

// 获取必填项
function queryBkCustomerRf(data) {
  return (0, _request.default)({
    url: '/ebusiness/docBkCustomerRf/queryBkCustomerRf',
    method: 'get'
  });
}

// 箱号的合理性和存在性校验
function validateContainerNo(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/validateContainerNo',
    method: 'post',
    data: data
  });
}

// Vgm导入箱号的合理性和存在性校验
function vgmImportvalidateContainerNo(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/excelImport2Validate',
    method: 'post',
    data: data
  });
}

// 批量提交
function batchCommit(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHeadCom/batchCommit',
    method: 'post',
    data: data
  });
}